import React from 'react'
import axios from 'axios'
import { Typography, TextField, Button, IconButton } from '@material-ui/core'
import { Delete as DeleteIcon, CheckCircle, CheckCircleOutline } from '@material-ui/icons'

const QuestionThread = ({ areaId, questions, url, user, onUpdated }) => {
  const [input, setInput] = React.useState('')
  const [answerInputs, setAnswerInputs] = React.useState({})

  const handleAsk = () => {
    if (!input.trim()) return
    axios.post(`${url}/api/bid-estimation/areas/${areaId}/questions`, { text: input.trim() })
      .then(res => { onUpdated(res.data); setInput('') })
      .catch(err => console.error('Failed to ask question:', err))
  }

  const handleAnswer = (questionId) => {
    const answer = answerInputs[questionId]
    if (!answer?.trim()) return
    axios.put(`${url}/api/bid-estimation/areas/${areaId}/questions/${questionId}/answer`, { answer: answer.trim() })
      .then(() => {
        setAnswerInputs(prev => ({ ...prev, [questionId]: '' }))
        // Refetch area to get updated questions
        axios.get(`${url}/api/bid-estimation/areas/${areaId}`).then(res => onUpdated(res.data.questions))
      })
      .catch(err => console.error('Failed to answer:', err))
  }

  const handleResolve = (questionId, resolved) => {
    axios.put(`${url}/api/bid-estimation/areas/${areaId}/questions/${questionId}/resolve`, { resolved })
      .then(() => {
        axios.get(`${url}/api/bid-estimation/areas/${areaId}`).then(res => onUpdated(res.data.questions))
      })
      .catch(err => console.error('Failed to resolve:', err))
  }

  const handleDelete = (questionId) => {
    axios.delete(`${url}/api/bid-estimation/areas/${areaId}/questions/${questionId}`)
      .then(res => onUpdated(res.data))
      .catch(err => console.error('Failed to delete:', err))
  }

  return (
    <div style={{ marginBottom: 16 }}>
      <Typography variant="subtitle2" style={{ fontWeight: 600, fontSize: 13, marginBottom: 4 }}>Questions</Typography>
      {(questions || []).map(q => (
        <div key={q._id} style={{ padding: '8px 0', borderBottom: '1px solid #f0f0f0' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 4 }}>
            <div style={{ flex: 1 }}>
              <Typography variant="body2" style={{ fontSize: 13, fontWeight: 500 }}>{q.text}</Typography>
              <Typography variant="caption" color="textSecondary">
                {new Date(q.askedAt).toLocaleDateString()}
              </Typography>
            </div>
            <IconButton size="small" onClick={() => handleResolve(q._id, !q.resolved)}
              title={q.resolved ? 'Unresolve' : 'Resolve'}>
              {q.resolved ? <CheckCircle fontSize="small" style={{ color: '#2e7d32' }} /> : <CheckCircleOutline fontSize="small" />}
            </IconButton>
            {(!q.resolved || q.askedBy === user?._id) && (
              <IconButton size="small" onClick={() => handleDelete(q._id)}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            )}
          </div>
          {q.answer && (
            <div style={{ marginLeft: 16, marginTop: 4, padding: '4px 8px', backgroundColor: '#f5f5f5', borderRadius: 4 }}>
              <Typography variant="body2" style={{ fontSize: 12 }}>{q.answer}</Typography>
              <Typography variant="caption" color="textSecondary">
                {q.answeredAt && new Date(q.answeredAt).toLocaleDateString()}
              </Typography>
            </div>
          )}
          {!q.answer && !q.resolved && (
            <div style={{ marginTop: 4, display: 'flex', gap: 4 }}>
              <TextField
                size="small"
                variant="outlined"
                placeholder="Answer..."
                value={answerInputs[q._id] || ''}
                onChange={e => setAnswerInputs(prev => ({ ...prev, [q._id]: e.target.value }))}
                onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), handleAnswer(q._id))}
                style={{ flex: 1 }}
                inputProps={{ style: { fontSize: 12, padding: '6px 8px' } }}
              />
              <Button size="small" onClick={() => handleAnswer(q._id)} variant="outlined"
                disabled={!answerInputs[q._id]?.trim()} style={{ textTransform: 'none', fontSize: 11 }}>
                Answer
              </Button>
            </div>
          )}
        </div>
      ))}
      <div style={{ display: 'flex', gap: 4, marginTop: 8 }}>
        <TextField
          size="small"
          variant="outlined"
          placeholder="Ask a question..."
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), handleAsk())}
          style={{ flex: 1 }}
          inputProps={{ style: { fontSize: 12, padding: '6px 8px' } }}
        />
        <Button size="small" onClick={handleAsk} disabled={!input.trim()} variant="outlined"
          style={{ textTransform: 'none', fontSize: 11 }}>
          Ask
        </Button>
      </div>
    </div>
  )
}

export default QuestionThread
